<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Under the Covers</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By K.C. Wells</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Can they find their HEA in Romancelandia?</p>
<p class="P_Normal">Chris Tyler loves his job. He photographs some of the hottest guys on the planet, but none stir him like Jase Mitchell. He’ll never let Jase know – he values their friendship too much to spoil it.</p>
<p class="P_Normal">Jase is looking forward to the Under The Covers Romance convention. It’s a great opportunity to connect with readers who want to meet their favorite cover model, but more importantly, with agents who could advance his career. Too bad the only person he yearns to connect with is Chris.</p>
<p class="P_Normal">What Chris wants is Jase in his life, but he’s afraid that’s sheer fantasy. What Jase desires is a Hollywood dream, but that will mean leaving Chris behind. What both crave is a real-life romance and their own Happily Ever After.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?4eea6318